import React from "react";
import { Card, Empty, Spin, Table, Typography } from "antd";
import { useOpenRoute } from "../../utils/openRouteUtils";

const { Title, Text } = Typography;

function InstitutionAccountsTable({
  title = "Bank Accounts",
  loading = false,
  accounts = [],
  columns = [],
}) {

  const openRoute = useOpenRoute();

  function handleRowClick(record, event) {
    if (!record?.id) return;
    openRoute(`/account/${record.id}`, event);
  }

  return (
    <Card className="rounded-2xl shadow-md">
      <div className="mb-4">
        <Title level={4} className="!mb-1">
          {title}
        </Title>
      </div>

      {loading ? (
        <div className="flex justify-center py-16">
          <Spin />
        </div>
      ) : accounts.length === 0 ? (
        <Empty description="No bank accounts found" />
      ) : (
        <Table
          rowKey="id"
          columns={columns}
          dataSource={accounts}
          pagination={false}
          scroll={{ x: 1500 }}
          onRow={(record) => ({
            onClick: (e) => handleRowClick(record, e),
            className: "cursor-pointer",
          })}
        />
      )}
    </Card>
  );
}

export default InstitutionAccountsTable;